import styled from '@emotion/styled'

import { useMemo, type FC } from 'react'

import FormSubmitMessage from '@segment/templates/FormSubmitMessage'

import { trackButtonClick } from '@segment/tracking/scripts'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const LINK_TEXT = `Explore what you can do with Twilio Segment`
const AlreadyHaveAWorkspace: FC = () => {
  const pageConfig = usePageConfig()
  const workspaceLink = getAbsoluteUrl(`/recipes/`, pageConfig)
  const message = useMemo(
    () => ({
      heading: `Already have a workspace?`,
      description: (
        <Link
          onClick={() => trackButtonClick({ buttonText: LINK_TEXT, buttonId: `Recipe`, targetUrl: workspaceLink })}
          href={workspaceLink}
        >
          {LINK_TEXT}
        </Link>
      ),
    }),
    [workspaceLink]
  )
  return (
    <Wrapper>
      <FormSubmitMessage form="demo" status="success" data-hook="demo-already-hava-a-workspace-message" {...message} />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-top: 40px;
`

const Link = styled.a`
  color: inherit;
  cursor: pointer;
`

export default AlreadyHaveAWorkspace
